import { useEffect, useRef, useState } from "react";
import { useConversationsApi } from "../api/conversationsApi";

/**
 * Busca no servidor com cancelamento da consulta anterior: digitar rápido gera
 * várias chamadas, e sem descartar as antigas o resultado que aparece na tela
 * pode ser o de um termo que o usuário já apagou.
 */
export function useConversationSearch(term, { enabled = true } = {}) {
  const api = useConversationsApi();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  useEffect(() => {
    const query = String(term || "").trim();

    if (!enabled || query.length < 2) {
      setResult(null);
      setLoading(false);
      return;
    }

    const current = ++requestId.current;
    setLoading(true);

    api
      .search(query)
      .then((data) => {
        if (current === requestId.current) setResult(data);
      })
      .catch(() => {
        if (current === requestId.current) setResult(null);
      })
      .finally(() => {
        if (current === requestId.current) setLoading(false);
      });
  }, [api, term, enabled]);

  return { result, loading };
}
